import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import IFile, { IFileForm } from "@/interfaces/File";
import api from "../api";
import { CompanyFileForm } from "@/interfaces/Company";
import { createFormDataRequest } from "@/helpers/FormHelpers";

export const companyFiles = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyFiles: build.query<IPaginateResponse<IFile>, [string, IFilters]>({
      query: ([id, params]) => ({
        url: `/companies/${id}/files`,
        params,
      }),
      providesTags: (result, _error, [companyId]) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyFiles" as const,
                companyId,
                id,
              })),
              { type: "CompanyFiles", companyId, id: "LIST" },
            ]
          : [{ type: "CompanyFiles", companyId, id: "LIST" }],
    }),

    storeCompanyFiles: build.mutation<IFile, [string, CompanyFileForm]>({
      query: ([id, data]) => {
        const body = createFormDataRequest(data);
        return {
          url: `/companies/${id}/files`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "CompanyFiles", id: "LIST" }],
    }),
    deleteCompanyFile: build.mutation<void, [string, string]>({
      query: ([companyId, id]) => ({
        url: `/companies/${companyId}/files/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, _error, [companyId, id]) => [
        { type: "CompanyFiles", companyId, id },
      ],
    }),
  }),

  overrideExisting: true,
});

export const {
  useDeleteCompanyFileMutation,
  useGetCompanyFilesQuery,
  useStoreCompanyFilesMutation,
} = companyFiles;
